export default function useQuestionsData(name) {
    const { ProductFinderHistoryId, Questions } = JSON.parse(JSON.stringify(window.finderData || {}));

    const questions = Questions.map(question => {
        question.QuestionDisplayText = question.QuestionDisplayText.replace(/\{0\}/gi, name);
        return question;
    });

    return {
        productFinderHistoryId: ProductFinderHistoryId,
        questions
    };
}